class ModalToggleDirective {
    constructor(ModalService) {
        this.restrict = 'A';
        this.service = ModalService;
    }

    link(scope, element, attrs, controllers) {
        const html = attrs.html || '';
        element.removeAttr('html');
        const title = attrs.title || null;
        element.removeAttr('title');
        const modal = this.service.add(title, html);

        const openModal = (event) => {
            event.stopPropagation();
            event.preventDefault();
            modal.open();
            scope.$apply();
        };

        element.on('click', openModal);

        scope.$on('$destroy', () => {
            element.off('click', openModal);
        });
    }

    static directiveFactory(ModalService) {
        'ngInject';
        return new ModalToggleDirective(ModalService);
    }
}

export default ModalToggleDirective;